import type { ReactElement } from "react";
import type { CameraPreset } from "../../scene/createCamera";
import type { InspectorPresentation } from "./BaseLayersCard";
import {
  InspectorChipButton,
  InspectorChipButtonGrid,
  InspectorChipButtonRow
} from "./InspectorChipButton";

/** Camera presets only move the rig; orbit-style framing is handled by panning.
 *  Shared with the top-nav compass menu (CameraCompassMenu). */
export const CAMERA_PRESET_ITEMS: { preset: CameraPreset; label: string }[] = [
  { preset: "topDown", label: "Top Down" },
  { preset: "roadApproach", label: "Road Approach" },
  { preset: "downhill", label: "Downhill View" },
  { preset: "sideSlope", label: "Side Slope" },
  { preset: "bestView", label: "Best View" },
  { preset: "solsticeMorning", label: "Sunny Morning" }
];

export interface CameraLayersCardProps {
  onPreset: (preset: CameraPreset) => void;
  presentation?: InspectorPresentation;
}

export function CameraLayersCard({
  onPreset,
  presentation = "inspector"
}: CameraLayersCardProps): ReactElement {
  const pairRows: (typeof CAMERA_PRESET_ITEMS)[number][][] = [];
  for (let i = 0; i < CAMERA_PRESET_ITEMS.length; i += 2) {
    pairRows.push(CAMERA_PRESET_ITEMS.slice(i, i + 2));
  }

  return (
    <InspectorChipButtonGrid>
      {pairRows.map((pair, ri) => (
        <InspectorChipButtonRow key={ri}>
          {pair.map((item) => (
            <InspectorChipButton
              key={item.preset}
              drawerRail={presentation === "drawer"}
              onClick={() => {
                onPreset(item.preset);
              }}
            >
              {item.label}
            </InspectorChipButton>
          ))}
        </InspectorChipButtonRow>
      ))}
    </InspectorChipButtonGrid>
  );
}
